import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

import Athletes from "../../components/Scout/Athletes";
import Inputs from "../../components/Scout/Inputs";
import Parametros from "../../components/Scout/Parametros";

import Gym from "../../components/Scout/Gym";
import { trocaLibero } from "../../components/Scout/utils.js";
import Plays from "../../components/Scout/Plays.jsx";
import PlaysPublic from "../../components/Scout/PlaysPublic.jsx";
import Sets from "../../components/Scout/Sets.jsx";
import { useParams } from "react-router-dom";
import ScoutAthletes from "../../components/Scout/ScoutAthletes.jsx";
import BasicReports from "../../components/Scout/basicReports.jsx";
import AbaScout from "../../components/Scout/abaScout";
import VideoRecorder from "../../components/Scout/VideoRecorder";
import VideoPlayerWithControls from "../../components/Scout/VideoPlayerWithControls";
import ScoutAthleteFundamentalsReport from "../../components/Scout/ScoutAthleteFundamentalsReport.jsx";
import ExportPDFButton from "../../components/Scout/ExportPDFButton";
import PlayerFilterPanel from "../../components/Scout/PlayerFilterPanel";
import StickySetScore from "../../components/Scout/StickySetScore";
import RotationReport from "../../components/Scout/RotationReport";

import useIsMobile from "../../hooks/useIsMobile";

const Scout = () => {
  const { id } = useParams();
  const [visitorNumbers, setVisitorNumbers] = useState(Array(6).fill(""));
  const [homeNumbers, setHomeNumbers] = useState(Array(6).fill(""));
  const [visitorInic, setVisitorInic] = useState(Array(6).fill(""));
  const [homeInic, setHomeInic] = useState(Array(6).fill(""));

  const [ultimoSet, setUltimoSet] = useState(1); // total de sets
  const [selectedSet, setSelectedSet] = useState("1"); // set selecionado

  const [tiimeSacador, setTimeSacador] = useState("*");
  const [partida, setPartida] = useState(id);
  const [numScout, setNumScout] = useState("");
  const [lastScout, setLastScout] = useState(null);
  const [firstScout, setFirstScout] = useState(null);
  const [lastPoint, setLastPoint] = useState(null);
  const [score, setScore] = useState([]);
  const [setterPosition, setSetterPostion] = useState([]);
  const [teams, setTeams] = useState(null);
  const [parametros, setParametros] = useState(null);
  const [homePlayers, setHomePlayers] = useState([]);
  const [awayPlayers, setAwayPlayers] = useState([]);
  const [teamNames, setTeamNames] = useState({
    home: null,
    away: null,
  });
  const [homeLeft, setHomeLeft] = useState(true);
  const [shouldUpdateHomeLeft, setShouldUpdateHomeLeft] = useState(true);
  const [shouldUpdateScore, setShouldUpdateScore] = useState(true);
  const [atualizaPosicao, setAtualizaPosicao] = useState(true);
  const [fullScore, setFullScore] = useState(null);
  const [atualizarPlacar, setAtualizarPlacar] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0); // trigger global
  const [aba, setAba] = useState("set"); // "set" ou "geral"

  const [tipoScout, setTipoScout] = useState(""); // pegue do backend
  const [publico, setPublico] = useState(false); // pegue do backend
  const [videoUrl, setVideoUrl] = useState(""); // pegue do backend

  const videoRef = useRef();
  const scoreRowRef = useRef();
  const [isScoreRowVisible, setIsScoreRowVisible] = useState(true);
  const isMobile = useIsMobile();

  const [selectedPlayerFilter, setSelectedPlayerFilter] = useState(null);
  const [athletesWithTempo, setAthletesWithTempo] = useState([]);

  /* ------------------ KEYBOARD SHORTCUTS ------------------ */
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === "ArrowLeft") {
        event.preventDefault();
        const current = videoRef.current?.getCurrentTime?.();
        if (typeof current === "number") {
          videoRef.current.seekTo(Math.max(current - 5, 0));
        }
      }
      if (event.ctrlKey && event.key === "ArrowRight") {
        event.preventDefault();
        const current = videoRef.current?.getCurrentTime?.();
        if (typeof current === "number") {
          videoRef.current.seekTo(current + 5);
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  /* ------------------ HELPERS ------------------ */
  const setIfDifferent = (setter, newValue, oldValue) => {
    const isEqual = JSON.stringify(newValue) === JSON.stringify(oldValue);
    if (!isEqual) setter(newValue);
  };

  /* ------------------ DATA FETCHING ------------------ */
  const fetchLastMatch = async () => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/matches/set`,
        {
          set: Number(selectedSet),
          partida,
        }
      );

      const ScoutData = response?.data[0];

      const initialHome = ScoutData.lastScout.Rotation.home;
      const initialVisitor = ScoutData.lastScout.Rotation.away;

      if (atualizaPosicao) {
        setHomeInic(ScoutData.firstScout.Rotation.home);
        setVisitorInic(ScoutData.firstScout.Rotation.away);
        setAtualizaPosicao(false);
      }

      setTimeSacador(ScoutData.lastScout.serving);
      setNumScout(ScoutData.scoutCount);
      setLastScout(ScoutData.lastScout);
      setLastPoint(ScoutData.lastPoint);
      setFirstScout(ScoutData.firstScout);
      setSetterPostion(ScoutData.lastScout.setters);

      if (shouldUpdateHomeLeft) setHomeLeft(ScoutData.firstScout.left);
      if (shouldUpdateScore) setScore(ScoutData.lastScout.score);

      if (teams) {
        const updatedHome = trocaLibero(
          initialHome,
          teams.home,
          ScoutData.lastScout.serving,
          "home"
        );
        const updatedVisitor = trocaLibero(
          initialVisitor,
          teams.away,
          ScoutData.lastScout.serving,
          "away"
        );

        setIfDifferent(setHomeNumbers, updatedHome, homeNumbers);
        setIfDifferent(setVisitorNumbers, updatedVisitor, visitorNumbers);
      } else {
        setIfDifferent(setHomeNumbers, initialHome, homeNumbers);
        setIfDifferent(setVisitorNumbers, initialVisitor, visitorNumbers);
      }
    } catch (error) {
      console.error("Erro ao buscar a última partida:", error);
    }
  };

  const fetchPlacarGeral = async () => {
    const response = await axios.post(
      `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/reports/placar-geral`,
      { partida }
    );
    setFullScore([response.data.home, response.data.away]);
  };

  /* ------------------ USE EFFECTS ------------------ */
  useEffect(() => {
    fetchPlacarGeral();
  }, [selectedSet, atualizarPlacar]);

  useEffect(() => {
    fetchLastMatch();
  }, [selectedSet, teams]);

  useEffect(() => {
    const fetchParametros = async () => {
      try {
        const response = await axios.post(
          `${
            import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/matches/parametros`,
          { partida }
        );
        const params = response?.data[0];

        setParametros(params);
        setUltimoSet(params.ultimoSet);
        setSelectedSet(String(params.ultimoSet));

        setTipoScout(params.tipoScout);
        setPublico(params.publico);
        setVideoUrl(params.video);

        setTeamNames({
          home: params?.times?.home,
          away: params?.times?.away,
        });
      } catch (error) {
        console.error("Erro ao consultar os parâmetros");
      }
    };

    fetchParametros();
  }, []);

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const response = await axios.post(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/rotation`,
          { partida }
        );
        setTeams(response?.data[0]);
      } catch (error) {
        console.error("Erro ao consultar os times");
      }
    };

    fetchTeams();
  }, [selectedSet]);

  useEffect(() => {
    if (!teams) return;

    const updatedHome = trocaLibero(
      homeNumbers,
      teams.home,
      tiimeSacador,
      "home"
    );
    setIfDifferent(setHomeNumbers, updatedHome, homeNumbers);

    const updatedVisitor = trocaLibero(
      visitorNumbers,
      teams.away,
      tiimeSacador,
      "away"
    );
    setIfDifferent(setVisitorNumbers, updatedVisitor, visitorNumbers);
  }, [teams, tiimeSacador]);

  /* ------------------ HANDLERS ------------------ */
  const handleScore = (value) => {
    setShouldUpdateScore(false);
    setScore(value);
  };

  const handleTeams = (value) => setTeams(value);
  const handlePositionHome = (value) => {
    setShouldUpdateHomeLeft(false);
    setHomeLeft(value);
  };
  const handleChangeSacador = (value) => setTimeSacador(value);
  const handleChangeSet = (value) => setSelectedSet(value);
  const handlePlacarGeral = () => setAtualizarPlacar((prev) => !prev);
  const handleChangeHome = (value) => {
    setHomeInic(value);
    setIfDifferent(setHomeNumbers, value, homeNumbers);
  };
  const handleChangeVisitor = (value) => {
    setVisitorInic(value);
    setAtualizaPosicao(false);
    setIfDifferent(setVisitorNumbers, value, visitorNumbers);
  };

  const handleScoutUpdate = () => fetchLastMatch();

  const refreshAll = () => {
    setRefreshKey((prev) => prev + 1);
    fetchLastMatch();
    fetchPlacarGeral();
    setAtualizarPlacar((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      refreshAll();
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  // Scroll observer para sticky score
  useEffect(() => {
    function handleScroll() {
      if (!scoreRowRef.current) return;
      const rect = scoreRowRef.current.getBoundingClientRect();
      // Troca quando o topo do placar do set chega a 100px do topo da viewport
      setIsScoreRowVisible(rect.top > 170);
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);
    // Chama uma vez para o estado inicial
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [scoreRowRef]);

  const handlePlay = (tempo) => videoRef.current?.seekTo?.(tempo);

  /* ------------------ RENDER ------------------ */
  return (
    <div className="px-4 py-8 max-w-7xl mx-auto mt-8">
      {/* Sets & Parametros */}
      <div className="sticky top-16 z-30 bg-white">
        <Sets
          home={teams?.home}
          away={teams?.away}
          teamNames={teamNames}
          fullScore={fullScore}
          positionHome={homeLeft}
          score={score}
        />
        <div className="sticky top-28  z-50 w-full bg-white">
          <StickySetScore
            placar={score}
            positionHome={homeLeft}
            teamNames={teamNames}
          />
        </div>
      </div>
      <div className="sticky top-[155px] z-30 bg-white pt-2">
        <Parametros
          numSet={ultimoSet}
          selectedSet={selectedSet}
          tiimeSacador={tiimeSacador}
          onChangeSacador={handleChangeSacador}
          onChangeSet={handleChangeSet}
        />

        <div className="text-white p-1 text-sm bg-blue-500 rounded-lg w-16 ">
          <button onClick={refreshAll}>Refresh</button>
        </div>
      </div>

      {/* FLEX CONTAINER COM ORDEM RESPONSIVA */}
      <div className="flex flex-col lg:flex-row gap-4 h-auto min-h-0">
        {/* 1. Gym + BasicReports + Inputs (mobile) */}
        <div className="order-1 lg:order-1 w-full lg:w-[400px] p-4 rounded-lg flex-shrink-0">
          <div ref={scoreRowRef} style={{ width: "100%" }}>
            <BasicReports
              partida={partida}
              numSet={selectedSet}
              positionHome={homeLeft}
              score={score}
              teamNames={teamNames}
              refreshKey={refreshKey}
              showScoreRow={isScoreRowVisible}
            />
          </div>
          <div className="flex z-99 justify-center items-center">
            <Gym
              visitorNumbers={visitorNumbers}
              homeNumbers={homeNumbers}
              tiimeSacador={tiimeSacador}
              placar={score}
              sette={setterPosition}
              times={teams}
              positionHome={handlePositionHome}
              homeLeft={homeLeft}
              numScout={numScout}
              partida={partida}
              numSet={selectedSet}
              teamNames={teamNames}
            />
          </div>
        </div>

        {/* 3. Athletes */}
        {homeLeft !== undefined && lastScout && (
          <div className="order-3 lg:order-2 flex-1">
            <Athletes
              tiimeSacador={tiimeSacador}
              setTiimeSacador={handleChangeSacador}
              idPartida={partida}
              onChangeHome={handleChangeHome}
              onChangeVisitor={handleChangeVisitor}
              funcaoAtleta={{ home: [], away: [] }}
              lastScout={lastScout}
              numScout={numScout}
              numSet={selectedSet}
              onChangeSacador={handleChangeSacador}
              homeLeft={homeLeft}
              onChangeTeams={handleTeams}
              teams={teams}
              teamNames={teamNames}
              ultimoSet={ultimoSet}
              setters={setterPosition}
            />
          </div>
        )}

        {/* 4. Plays */}
        {tipoScout !== "video" && (
          <div className="order-4 fl)ex flex-col w-[300px] items-center h-[500px] min-h-0 p-0 m-0 lg:order-3 flex-1">
            <Plays
              partida={partida}
              set={selectedSet}
              ultimoSet={ultimoSet}
              numScout={numScout}
              onChangeScore={handleScore}
              placar={score}
              onPlacarGeral={handlePlacarGeral}
              refreshKey={refreshKey}
              teamNames={teamNames}
              onPlay={handlePlay}
              onJogadasChange={(jogadas) => {
                const withTempo = jogadas
                  .filter(
                    (j) =>
                      j.tempo && typeof j.cod === "string" && j.cod.length >= 3
                  )
                  .map((j) => ({
                    side:
                      j.cod[0] === "*"
                        ? "home"
                        : j.cod[0] === "a"
                        ? "away"
                        : "",
                    number: j.cod.slice(1, 3),
                  }));
                setAthletesWithTempo(withTempo);
              }}
              maxHeight={500}
            />
          </div>
        )}
      </div>

      {/* SEÇÃO DE VÍDEO */}
      <div className="mt-12 flex justify-center">
        {tipoScout === "video" && videoUrl ? (
          <div className="flex flex-col lg:flex-row items-center lg:items-start w-full">
            {!isMobile && (
              <div className="flex flex-col lg:flex-row items-center lg:items-start w-full">
                <div className="w-full max-w-[950px]">
                  <VideoPlayerWithControls ref={videoRef} url={videoUrl} />
                </div>
                {!isMobile && (
                  <div className="flex flex-col w-full mt-4 lg:mt-0 lg:ml-4 gap-2 h-[530px] max-h-[530px] min-h-[300px]">
                    <PlayerFilterPanel
                      teams={teams}
                      homeNumbers={homeNumbers}
                      awayNumbers={visitorNumbers}
                      selectedPlayer={selectedPlayerFilter}
                      onSelectPlayer={setSelectedPlayerFilter}
                      athletesWithTempo={athletesWithTempo}
                      teamNames={teamNames}
                    />
                    <Plays
                      partida={partida}
                      set={selectedSet}
                      ultimoSet={ultimoSet}
                      numScout={numScout}
                      onChangeScore={handleScore}
                      placar={score}
                      onPlacarGeral={handlePlacarGeral}
                      refreshKey={refreshKey}
                      teamNames={teamNames}
                      onPlay={handlePlay}
                      playerFilter={selectedPlayerFilter}
                      onClearPlayerFilter={() => setSelectedPlayerFilter(null)}
                      maxHeight={280}
                    />
                  </div>
                )}
              </div>
            )}
            {isMobile && (
              <div className="flex flex-col lg:flex-row items-center lg:items-start w-full">
                <div className="w-full">
                  <VideoPlayerWithControls ref={videoRef} url={videoUrl} />
                </div>
                {isMobile && (
                  <div className="flex flex-col w-[300px] mt-4 lg:mt-0 lg:ml-4 gap-2 h-[400px] max-h-[400px] min-h-[400px]">
                    <PlayerFilterPanel
                      teams={teams}
                      homeNumbers={homeNumbers}
                      awayNumbers={visitorNumbers}
                      selectedPlayer={selectedPlayerFilter}
                      onSelectPlayer={setSelectedPlayerFilter}
                      athletesWithTempo={athletesWithTempo}
                      teamNames={teamNames}
                    />
                    <Plays
                      partida={partida}
                      set={selectedSet}
                      ultimoSet={ultimoSet}
                      numScout={numScout}
                      onChangeScore={handleScore}
                      placar={score}
                      onPlacarGeral={handlePlacarGeral}
                      refreshKey={refreshKey}
                      teamNames={teamNames}
                      onPlay={handlePlay}
                      playerFilter={selectedPlayerFilter}
                      onClearPlayerFilter={() => setSelectedPlayerFilter(null)}
                      maxHeight={280}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        ) : tipoScout === "live" ? (
          <div className="flex flex-col lg:flex-row items-center lg:items-start w-full">
            <div className="w-full max-w-[800px]">
              <VideoRecorder
                ref={videoRef}
                teamNames={teamNames}
                set={selectedSet}
              />
            </div>
            {!isMobile && (
              <div className="flex flex-col lg:flex-row w-full mt-4 lg:mt-0 lg:ml-4 gap-2">
                <Plays
                  partida={partida}
                  set={selectedSet}
                  ultimoSet={ultimoSet}
                  numScout={numScout}
                  onChangeScore={handleScore}
                  placar={score}
                  onPlacarGeral={handlePlacarGeral}
                  refreshKey={refreshKey}
                  teamNames={teamNames}
                  onPlay={handlePlay}
                  playerFilter={selectedPlayerFilter}
                  onClearPlayerFilter={() => setSelectedPlayerFilter(null)}
                />
                <PlayerFilterPanel
                  teams={teams}
                  homeNumbers={homeNumbers}
                  awayNumbers={visitorNumbers}
                  selectedPlayer={selectedPlayerFilter}
                  onSelectPlayer={setSelectedPlayerFilter}
                  athletesWithTempo={athletesWithTempo}
                  teamNames={teamNames}
                />
              </div>
            )}
          </div>
        ) : null}
      </div>

      {/* ABA SCOUT */}
      <div className="mt-2">
        <AbaScout aba={aba} onChangeAba={setAba} />
        {/* Renderiza SOMENTE a aba selecionada visível */}
        {aba === "set" ? (
          <ScoutAthletes
            set={selectedSet}
            partida={partida}
            homeNumbers={homeNumbers}
            awayNumbers={visitorNumbers}
            teamNames={teamNames}
            teams={teams}
          />
        ) : aba === "rotacao" ? (
          <RotationReport
            partida={partida}
            set={selectedSet}
            teamNames={teamNames}
            refreshKey={refreshKey}
          />
        ) : aba === "geral" ? (
          <ScoutAthletes
            partida={partida}
            homeNumbers={homeNumbers}
            awayNumbers={visitorNumbers}
            teamNames={teamNames}
            teams={teams}
          />
        ) : aba === "fundamentos" ? (
          <ScoutAthleteFundamentalsReport
            partida={partida}
            teamNames={teamNames}
            teams={teams}
          />
        ) : null}
        {/* Botão de Exportação PDF */}
        <ExportPDFButton
          partida={partida}
          teamNames={teamNames}
          teams={teams}
          selectedSet={selectedSet}
          ultimoSet={ultimoSet}
          homeNumbers={homeNumbers}
          awayNumbers={visitorNumbers}
          currentTab={aba}
          data={parametros?.data}
          hora={parametros?.hora}
          campeonato={parametros?.liga}
          temporada={parametros?.temporada}
          local={parametros?.local}
          placarGeral={parametros?.placarGeral}
          placarSets={parametros?.placarSets}
        />
        {/* Renderiza TODAS as tabelas de sets escondidas para exportação PDF */}
        <div
          style={{
            position: "absolute",
            left: "-9999px",
            top: 0,
            width: "1px",
            height: "1px",
            overflow: "hidden",
          }}
        >
          {[...Array(Number(ultimoSet)).keys()].map((i) => (
            <div
              key={i}
              data-set={i + 1}
              style={{ background: "#fff", padding: 0, margin: 0 }}
            >
              <ScoutAthletes
                set={String(i + 1)}
                partida={partida}
                homeNumbers={homeNumbers}
                awayNumbers={visitorNumbers}
                teamNames={teamNames}
                teams={teams}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Scout;
